import React, { useEffect } from 'react';
import { GifComponent, GifSectionProps, StrapiImage } from '../../../../global';
import { pathForStrapiImage } from '../../../../helpers/utils';
import HeroSection from '../../../HeroSection/HeroSection';
import { useNavigate } from 'react-router-dom';

function GifSectionComponent(props: GifSectionProps) {
  const redirect = useNavigate();
  useEffect(() => {
    console.log(props);
  }, [props]);
  return (
    <HeroSection
      key={props.id}
      minHeight="70vh"
      alpha={0.6}
      onClick={() => props.link && !props.buttontext && window.open(`${props.link}`, `${props.target ? props.target : '_self'}`)}
      bgColor="#304053"
      bgImage={pathForStrapiImage(props.image)}
      bgVideo={pathForStrapiImage(props.image)}
    >
      {props.title && <h1 className={`bold-title color-${props.titlecolor}`}>{props.title}</h1>}
      {props.subtitle && <h3 className={`sub-title color-${props.subtitlecolor}`}>{props.subtitle}</h3>}
      {props.buttontext && (
        <a href={props.link} target={`${props.target ? props.target : '_self'}`}>
          <button className={`btn-${props.buttoncolor} rounded mt-4`}>{props.buttontext}</button>
        </a>
      )}
    </HeroSection>
  );
}

export default GifSectionComponent;
